import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
// import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false

document.title = '空白Lonay';

router.beforeEach((to, from, next) => {
  if (to.meta.title) {//判断是否有标题
    document.title = to.meta.title + ' | 空白Lonay'
  }
  if(to.meta.auth) {//如果要登陆
    if(localStorage.getItem('ms-user-sessionToken') == '""' || localStorage.getItem('ms-user-sessionToken') == '' || localStorage.getItem('ms-user-sessionToken') == null || !localStorage.getItem('ms-user-sessionToken')){
      next({//如果没登陆
        path: '/account/login',
        query: { redirect: to.fullPath }
      });
    }else{
      next();
    }
  }else{
    next();
  }

})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
